<template>
  <div id="person_select">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="orderForm.pageList"
    />
    <div class="container">
      <div class="title">
        <h1>担当者入力画面</h1>
      </div>
      <div class="input_area">
        <div class="input_column">
          <div>店舗名</div>
          <select v-model="selBusinessId" @change="changeBusiness">
            <option hidden class="select_placeholder">選択ください</option>
            <option v-for="(bus,index) in businessList" :key="'business-' + index" v-bind:value="bus[0].cofficeId">{{bus[0].cofficeName}}</option>
          </select>
        </div>
        <div class="input_column">
          <div>担当者</div>
          <select v-model="selUserAccount">
            <option hidden class="select_placeholder">選択ください</option>
            <option v-for="(usr,index) in userList" :key="'user-' + index" v-bind:value="usr">{{usr.userData.cuserLastName}} {{usr.userData.cuserFirstName}}</option>
          </select>
          <div class="order_link" @click="skip"><a>SKIP</a></div>
        </div>
        <div v-if="errors.person" class="error_text middle_text">{{errors.person}}</div>
      </div>
      <div class="control_btn_area">
        <div class="detail_btn2" @click="onPrev()">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
        <div class="detail_btn" :disabled="!isSelectedList" @click="confirm()">{{nextButtonLabel}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'

export default {
  name: 'OrderInput',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap
  },
  data () {
    return {
      pageKey: 'personSelect',
      personList: [],
      orderForm: {},
      selBusinessId: {},
      selUserAccount: {},
      errors: {}
    }
  },
  methods: {
    skip: function () {
      if (this.isCarryIn) {
        this.$router.push({
          name: 'ConstructInput'
        })
      } else {
        this.$router.push({
          name: 'OrderInput'
        })
      }
    },
    confirm: function () {
      // check
      this.errors = {}
      if (!this.selUserAccount || !this.selUserAccount.cuserId) {
        this.errors['person'] = '店舗名、担当者を選択してください'
      }
      if (Object.keys(this.errors).length !== 0) return
      this.$set(this.orderForm, 'person', this.selUserAccount)
      App.setLocalStorage(DC_STORAGE_KEY.ORDER_DATA, this.orderForm)
      if (this.isCarryIn) {
        this.$router.push({
          name: 'ConstructInput'
        })
      } else {
        this.$router.push({
          name: 'OrderInput'
        })
      }
    },
    onPrev: function () {
      this.$router.go(-1)
    },
    getPersonList: function () {
      axios.get(DC_URL.ORDER + '/person', {})
        .then(response => {
          this.personList = response.data.data
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      if (Object.keys(lorder).length > 0) {
        this.orderForm = Object.assign({}, lorder)
      }
    },
    changeBusiness: function () {
      this.selUserAccount = {}
    }
  },
  computed: {
    isSelectedList: function () {
      return false
    },
    businessList: function () {
      let businessList = App.groupBy(this.personList, 'cofficeId')
      console.log(businessList)
      return businessList
    },
    userList: function () {
      if (!this.selBusinessId) return []
      return this.businessList[this.selBusinessId]
    },
    isCarryIn: function () {
      if (this.orderForm && this.orderForm.isCarryIn) return true
      return false
    },
    nextButtonLabel: function () {
      if (this.isCarryIn) {
        return '組立設置先入力 〉〉'
      } else {
        return '納品先入力画面 〉〉'
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getPersonList()
    let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    if (Object.keys(lorder).length > 0) {
      this.orderForm = Object.assign({}, lorder)
    }
  },
  created () {
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcPersonSelect.vue